import PropTypes from "prop-types";
import { useAccordionButton } from "react-bootstrap/AccordionButton";

function CustomToggle(props) {
  const { children, eventKey, selectedAccordion, setSelectedAccordion } = props;
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setSelectedAccordion((prev) => {
      if (eventKey === prev) return "-1";
      return eventKey;
    })
  );

  return (
    <button
      type="button"
      className={`custom-accordion__button ${
        eventKey === selectedAccordion
          ? "custom-accordion__button--selected"
          : ""
      }`}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}
CustomToggle.defaultProps = {};

CustomToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
  selectedAccordion: PropTypes.string.isRequired,
  setSelectedAccordion: PropTypes.func.isRequired,
};

export default CustomToggle;
